class Pagination extends HTMLElement {
  constructor() {
    super();

    this.PAGINATION = ".js-pagination";

    this.nextPage = Number(this.dataset.nextPage);
    this.totalPages = Number(this.dataset.total);
    this.grid = this.dataset.grid;
    this.items = document.querySelector(`.${this.grid}`);
    this.trigger = this.querySelector(".js-loader");
    this.triggerType = this.dataset.triggerType;
    this.url = new URL(window.location.href);
    this.loading = false;

    if (this.trigger) {
      this.triggerType === "button" ? this.addClickListener() : this.addObserver();
    }
  }

  addClickListener() {
    this.trigger.addEventListener("click", () => {
      if (!this.loading) this.getSection(this.nextPage);
    });
  }

  addObserver() {
    const options = { root: null, rootMargin: "100px", threshold: 0.25 };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
    this.observer.observe(this.trigger);
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (this.nextPage > this.totalPages) {
        return this.observer.unobserve(entry.target);
      }

      if (entry.isIntersecting && !this.loading) {
        this.getSection(this.nextPage);
      }
    });
  }

  getSection() {
    const pageUrl = this.getPageUrl(this.nextPage);
    const section = this.getSectionUrl(pageUrl);

    this.loading = true;
    this.trigger.classList.add('loading');

    fetch(section)
      .then(response => response.text())
      .then(data => this.updateSection(data))
      .finally(() => {
        this.loading = false;
        this.trigger.classList.remove('loading');
      });
  }

  getPageUrl(page) {
    const path = window.location.href;
    const url = symbol => path + symbol + 'page=' + page;

    return path.includes('page=')
      ? this.setSearchParam(path, page)
      : path.includes('?')
        ? url('&')
        : url('?');
  }

  setSearchParam(path, page) {
    this.url.searchParams.set('page', page.toString());
    this.url.search = this.url.searchParams.toString();

    return this.url.toString();
  }

  getSectionUrl(page) {
    const section = this.getAttribute('data-pagination-section');

    return page + '&section_id=' + section;
  }

  updateSection(section) {
    const dataHtml = new DOMParser().parseFromString(section, "text/html");
    const items = dataHtml.querySelector(`.${this.grid}`).children;
    const pagination = dataHtml.querySelector(this.PAGINATION);

    this.addNextPageItems(items, pagination);
  }

  addNextPageItems(items, pagination) {
    while (items.length > 0) this.items.append(items[0]);

    document.querySelector(this.PAGINATION).replaceWith(pagination);
  }
}

customElements.define('infinite-pagination', Pagination);